const menuItems2 = {
    items: [
      {
        id: 'content-panel',
        title: 'Content Panel',
        type: 'group',
        icon: 'icon-monitor',
        children: [
          {
            id: 'main-dashboard',
            title: 'Dashboard',
            icon: 'feather icon-home',
            type: 'item',
            url: '/admin-portal/admin-dashboard'
          },
          
        ]
      },
    ]
  }
  
  export default menuItems2;